<template>
  <el-row>
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
      </el-header>
      <el-main>
        <!-- <div class="alert">
          <div class="alert-wrapper">
            <h2>{{ $t("pay-out.maintenance.title") }}</h2>
            <p>
              {{ $t("pay-out.maintenance.text") }}
            </p>
          </div>
        </div> -->
        <el-row>
          <div
            v-if="activeStep === 2 || activeStep === 3"
            class="go-back-arrow mb-20"
            @click="goBack"
          >
            <i class="el-icon-arrow-left" />
          </div>
        </el-row>
        <el-steps
          :active="activeStep"
          class="mb-20"
        >
          <el-step
            :title="$t('re-conciliation.choose-team.title')"
            icon="el-icon-user-solid"
          />
          <el-step
            :title="$t('re-conciliation.set-date.title')"
            icon="el-icon-date"
          />
          <el-step
            :title="$t('re-conciliation.set-amount.title')"
            icon="el-icon-money"
          />
          <el-step
            :title="$t('re-conciliation.thank-you.title')"
            icon="el-icon-check"
          />
        </el-steps>
        <router-view />
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '../Menu/Menu';

export default {
  name: 'ReConciliation',
  components: {
    Menu
  },
  data: () => ({
    activeStep: 1
  }),
  created () {
    this.setActiveStep(this.$route.name);
  },
  watch: {
    $route (to) {
      this.setActiveStep(to.name);
    }
  },
  methods: {
    setActiveStep (routeName) {
      if (routeName === 'SelectTeam') {
        this.activeStep = 1;
      } else if (routeName === 'SetDate') {
        this.activeStep = 2;
      } else if (routeName === 'SetAmount') {
        this.activeStep = 3;
      } else if (routeName === 'ReConciliationThankYou') {
        this.activeStep = 4;
      }
    },
    goBack () {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.go-back-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 2px solid #000000;
  border-radius: 8px;
  cursor: pointer;
}
</style>
